import(/* webpackMode: "eager" */ "/var/www/html/tvfoco-headless/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Ads/grumft-iab-ad.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/tvfoco-headless/src/app/Components/Home/columnists.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Home/shorts-section.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Others/client-push-notification-card.js");
